import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/Bits";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export default function Contact() {
  const [c, setC] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setC((r.data || {}).contact || {})); }, []);

  const mobile = c.mobile || "9907267718";
  const items = [
    { icon: MapPin, label: "Address", value: c.address },
    { icon: Phone, label: "Landline", value: c.phone, href: c.phone ? `tel:${c.phone.replace(/\s/g, "")}` : null },
    { icon: Phone, label: "Mobile", value: mobile, href: `tel:${mobile.replace(/\s/g, "")}` },
    { icon: Mail, label: "Email", value: c.email, href: c.email ? `mailto:${c.email}` : null },
  ];

  return (
    <div data-testid="contact-page">
      <PageHeader title="Contact Us" subtitle={c.name || "High Court Advocates' Bar Association, Jabalpur"} />
      <section className="max-w-6xl mx-auto px-4 py-16 grid lg:grid-cols-2 gap-10">
        <div>
          <h2 className="font-display text-2xl font-bold text-[#0B2E63] mb-2">{c.name}</h2>
          <div className="gold-rule w-20 mb-8" />
          <div className="space-y-6">
            {items.map((it, i) => (
              <div key={i} className="flex items-start gap-4" data-testid={`contact-${it.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="w-11 h-11 rounded-full bg-[#EAF1FB] border border-[#E6C687] flex items-center justify-center text-[#123B7A] shrink-0"><it.icon size={20} /></div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#8A6320] font-semibold">{it.label}</div>
                  {it.href ? <a href={it.href} className="text-[#2a2422] font-medium hover:text-[#123B7A]">{it.value}</a> : <div className="text-[#2a2422] font-medium">{it.value || "—"}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="card-elite rounded-lg overflow-hidden min-h-[360px]" data-testid="contact-map">
          <iframe title="HC ABA Location" src={c.map_embed || "https://www.google.com/maps?q=High+Court+of+Madhya+Pradesh+Jabalpur&output=embed"}
            className="w-full h-full min-h-[360px] border-0" loading="lazy" />
        </div>
      </section>
    </div>
  );
}
